import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { trackCompleteRegistration } from "@/lib/pixel";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) {
      navigate("/login");
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId });
        setUser(data.user);
        window.history.replaceState(null, "", window.location.pathname);
        // First-time Google user: create a book and jump straight to the questionnaire.
        try {
          const { data: booksResp } = await api.get("/books");
          const list = booksResp?.books || [];
          if (list.length === 0) {
            // First-time Google user detected (no books yet).
            trackCompleteRegistration({ method: "google" });
            const { data: newBook } = await api.post("/books", {});
            navigate(`/books/${newBook.book_id}/questionario`);
            return;
          }
        } catch {
          /* if the books lookup fails, just fall back to the dashboard */
        }
        navigate("/dashboard", { state: { user: data.user } });
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-ink" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-4">
        <div className="h-10 w-10 animate-spin rounded-full border-2 border-white/10 border-t-[#D4AF37]" />
        <p className="text-sm text-white/50">Accesso in corso…</p>
      </div>
    </div>
  );
}
